// extracted by mini-css-extract-plugin
export default {"bio":"tY","about":"uY","title":"vY","text":"wY","fun_facts":"xY","fun":"yY","icon":"zY","bio_header":"AY"};
    if(module.hot) {
      // 1711394580003
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  